import { AxiosRequestConfig } from 'axios'

const addArticle = (url: string, data: any): AxiosRequestConfig => {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    url: `${url}`,
    data
  }
}

export default addArticle
